
import React from 'react';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/components/ui/card';
import { Button } from '@/components/ui/button';
import { Switch } from '@/components/ui/switch';

const NotificationSettings = () => {
  // Mock notification preferences
  const notificationPreferences = [
    {
      category: 'System Notifications',
      preferences: [
        { id: 'system_updates', label: 'System Updates', description: 'Receive notifications about system updates and maintenance', enabled: true },
        { id: 'security_alerts', label: 'Security Alerts', description: 'Get notified about important security events', enabled: true },
        { id: 'account_activity', label: 'Account Activity', description: 'Notifications about sign-ins and account changes', enabled: true },
      ]
    },
    {
      category: 'Content Notifications',
      preferences: [
        { id: 'content_published', label: 'Content Published', description: 'When new content is published', enabled: true },
        { id: 'content_updates', label: 'Content Updates', description: 'When existing content is modified', enabled: false },
        { id: 'content_comments', label: 'Comments', description: 'When users leave comments on your content', enabled: true },
      ]
    },
    {
      category: 'User Management',
      preferences: [
        { id: 'new_users', label: 'New Users', description: 'When new users register or are added', enabled: false },
        { id: 'user_permissions', label: 'Permission Changes', description: 'When user roles or permissions are updated', enabled: true },
      ]
    }
  ];
  
  return (
    <div className="max-w-3xl">
      <Card>
        <CardHeader>
          <CardTitle>Notification Preferences</CardTitle>
          <CardDescription>
            Control which notifications you receive and how they are delivered.
          </CardDescription>
        </CardHeader>
        <CardContent>
          <div className="space-y-6">
            {notificationPreferences.map((category, index) => (
              <div key={index} className="space-y-4">
                <h3 className="text-lg font-medium">{category.category}</h3>
                
                <div className="space-y-3">
                  {category.preferences.map((pref) => (
                    <div key={pref.id} className="flex justify-between items-start py-2 border-b last:border-0">
                      <div>
                        <p className="font-medium">{pref.label}</p>
                        <p className="text-sm text-muted-foreground">{pref.description}</p>
                      </div>
                      <Switch id={pref.id} defaultChecked={pref.enabled} />
                    </div>
                  ))}
                </div>
              </div>
            ))}
            
            <div className="pt-4">
              <h3 className="text-lg font-medium mb-4">Notification Delivery</h3>
              
              <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                <div className="border rounded-md p-4">
                  <div className="flex justify-between items-center">
                    <div>
                      <p className="font-medium">Email Notifications</p>
                      <p className="text-sm text-muted-foreground">Receive notifications via email</p>
                    </div>
                    <Switch id="email_notifications" defaultChecked={true} />
                  </div>
                </div>
                
                <div className="border rounded-md p-4">
                  <div className="flex justify-between items-center">
                    <div>
                      <p className="font-medium">In-App Notifications</p>
                      <p className="text-sm text-muted-foreground">Show notifications in the app</p>
                    </div>
                    <Switch id="inapp_notifications" defaultChecked={true} />
                  </div>
                </div>
              </div>
            </div>
            
            <div className="flex justify-end gap-2 pt-4">
              <Button variant="outline">Reset to Defaults</Button>
              <Button>Save Preferences</Button>
            </div>
          </div>
        </CardContent>
      </Card>
    </div>
  );
};

export default NotificationSettings;
